import React, { Fragment } from 'react';
import styles from './TableBox.module.scss';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import { XPagination } from '@/components/xqxc_ui';
import { tooltipStyle, tooltip } from '@/components/TableCell';
import moment from 'moment';

const TableBox = ({ tableData: { dataList = [], pageNum, pageSize, resultTotal }, onPageChange, onPageJump }) => {

    const onOperateCell = (id, item) => {
        return <div className={styles.action}>
            {
                item.applicantType === 'COMPANY' ?
                    <Fragment>
                        <div className={styles.item} onClick={() => onPageJump('运营公司详情', `/operatorinfo/${item.applicantId}/${id}`)}>查看详情</div>
                        {
                            item.auditState === 'WAIT' &&
                            <div className={styles.item} onClick={() => onPageJump('审核运营公司', `/auditoperator/${item.applicantId}/${id}`)}>审核</div>
                        }
                    </Fragment> :
                    <Fragment>
                        <div className={styles.item} onClick={() => onPageJump('经纪人详情', `/brokerinfo/${item.applicantId}/${id}`)}>查看详情</div>
                        {
                            item.auditState === 'WAIT' &&
                            <div className={styles.item} onClick={() => onPageJump('审核经纪人', `/auditbroker/${item.applicantId}/${id}`)}>审核</div>
                        }
                    </Fragment>
            }
        </div>;
    };

    const columns = [
        {
            title: '手机号码',
            dataIndex: 'applicantTel',
            key: 'applicantTel',
            width: '15%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '申请方',
            dataIndex: 'applicantTypeName',
            key: 'applicantTypeName ',
            width: '15%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '类型',
            dataIndex: 'auditTypeName',
            key: 'auditTypeName',
            width: '15%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '状态',
            dataIndex: 'auditStateName',
            key: 'auditStateName',
            width: '15%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '申请时间',
            dataIndex: 'gmtCreate',
            key: 'gmtCreate',
            width: '15%',
            align: 'center',
            onCell: tooltipStyle,
            render: text => text ? tooltip(moment(text).format('YYYY-MM-DD HH:mm:ss')) : ''
        },
        {
            title: '操作',
            dataIndex: 'auditId',
            key: 'auditId',
            width: '15%',
            align: 'center',
            onCell: tooltipStyle,
            render: onOperateCell
        }
    ];

    return <div className={styles.tableContainer}>
        <Table
            rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
            rowKey={record => record.auditId}
            columns={columns}
            dataSource={dataList}
            pagination={false}
            scroll={{ y: true }}
        />
        <XPagination
            resultTotal={resultTotal}
            pageSize={pageSize}
            pageNum={pageNum}
            onChange={onPageChange}
        />
    </div>;
};

TableBox.propTypes = {
    onPageChange: PropTypes.func,//分页变化
    tableData: PropTypes.object,//表格数据
    onPageJump: PropTypes.func,//页面跳转
};

export default TableBox;